export const impressum = {
  legalDisclosure: 'Impressum',
  declaration: 'Kontakt-Adresse',
  vermando: 'Vermando AG',
  address: 'Bahnhofstrasse 4',
  postal: 'CH-9100 Herisau',
  country: 'Schweiz',
  contact: 'E-Mail:',
  contactPerson: 'kontakt@vermando.com',
  authorizedPerson: 'Vertretungsberechtigte Person(en)',
  authorizedPersonText1: 'Roth Oliver, Präsident des Verwaltungsrates',
  authorizedPersonText2: 'Wittwer Oliver, Mitglied des Verwaltungsrates',
  authorizedPersonText3: 'Preiss Paul, Mitglied des Verwaltungsrates',
  authorizedPersonText4: 'Habisreutinger Claudius, Mitglied des Verwaltungsrates',
  authorizedPersonText5: 'Pfeifer Matthias, Mitglied des Verwaltungsrates',
  commercialRegister: 'Handelsregister-Eintrag',
  commercialRegisterText1: 'Eingetragener Firmenname:',
  commercialRegisterText2: 'Vermando AG',
  register: 'Unternehmens-Nr (UID):',
  registerStandard: 'CHE-386.055.781',
  valueTax: 'Mehrwertsteuer-Nummer',
  valueTaxStandard: 'CHE-386.055.781 MWST',
  disclaimer: 'Haftungsauschluss',
  disclaimerText1:
    'Der Autor übernimmt keinerlei Gewähr hinsichtlich der inhaltlichen Richtigkeit, Genauigkeit, Aktualität, Zuverlässigkeit und Vollständigkeit der Informationen.',
  disclaimerText2:
    'Haftungsansprüche gegen den Autor wegen Schäden materieller oder immaterieller Art, welche aus dem Zugriff oder der Nutzung bzw. Nichtnutzung der veröffentlichten Informationen, durch Missbrauch der Verbindung oder durch technische Störungen entstanden sind, werden ausgeschlossen.',
  disclaimerText3:
    'Alle Angebote sind unverbindlich. Der Autor behält es sich ausdrücklich vor, Teile der Seiten oder das gesamte Angebot ohne besondere Ankündigung zu verändern, zu ergänzen, zu löschen oder die Veröffentlichung zeitweise oder endgültig einzustellen.',
  disclaimerLink: 'Haftungsauschluss für Links',
  disclaimerLinkText1:
    'Verweise und Links auf Webseiten Dritter liegen ausserhalb unseres Verantwortungsbereichs. Es wird jegliche Verantwortung für solche Webseiten abgelehnt. Der Zugriff und die Nutzung solcher Webseiten erfolgen auf eigene Gefahr des jeweiligen Nutzers.',
  copyright: 'Urheberrechte',
  copyrightText1a:
    'Die Urheber- und alle anderen Rechte an Inhalten, Bildern, Fotos oder anderen Dateien auf dieser Website, gehören ausschliesslich ',
  copyrightText2a: 'der Firma Vermando AG ',
  copyrightText3a:
    'oder den speziell genannten Rechteinhabern. Für die Reproduktion jeglicher Elemente ist die schriftliche Zustimmung des Urheberrechtsträgers im Voraus einzuholen.',
  copyright1: 'Urheberrechtliche Hinweise',
  copyrightText1: '© 1001color - Fotolia.com',
  copyrightText2: '© Africa Studio - Fotolia.com',
  copyrightText3: '© Aleks Kend - Fotolia.com',
  copyrightText4: '© Alexander Raths - Fotolia.com',
  copyrightText5: '© alexandre zveiger - Fotolia.com',
  copyrightText6: '© andreaobzerova - Fotolia.com',
  copyrightText7: '© Andy Dean - Fotolia.com',
  copyrightText8: '© antbphotos - Fotolia.com',
  copyrightText9: '© arsdigital - Fotolia.com',
  copyrightText10: '© Ayamap - Fotolia.com',
  copyrightText11: '© Bacho Foto - Fotolia.com',
  copyrightText12: '© bannafarsai - Fotolia.com',
  copyrightText13: '© barkova natalia - Fotolia.com',
  copyrightText14: '© blackzheep - Fotolia.com',
  copyrightText15: '© bmak - Fotolia.com',
  copyrightText16: '© Boggy - Fotolia.com',
  copyrightText17: '© bramgino - Fotolia.com',
  copyrightText18: '© by-studio - Fotolia.com',
  copyrightText19: '© Cello Armstrong - Fotolia.com',
  copyrightText20: '© Cifotart - Fotolia.com',
  copyrightText21: '© cocci65 - Fotolia.com',
  copyrightText22: '© Comauthor - Fotolia.com',
  copyrightText23: '© contrastwerkstatt - Fotolia.com',
  copyrightText24: '© Dariusz Jarzabek - Fotolia.com',
  copyrightText25: '© dbunn - Fotolia.com',
  copyrightText26: '© deagreez - Fotolia.com',
  copyrightText27: '© deepvalley - Fotolia.com',
  copyrightText28: '© denisismagilov - Fotolia.com',
  copyrightText29: '© DiMmEr - Fotolia.com',
  copyrightText30: '© Dirk Vonten - Fotolia.com',
  copyrightText31: '© DragonImages - Fotolia.com',
  copyrightText32: '© drubig-photo - Fotolia.com',
  copyrightText33: '© Eléonore H - Fotolia.com',
  copyrightText34: '© Fabian - Fotolia.com',
  copyrightText35: '© Fiedels - Fotolia.com',
  copyrightText36: '© fotomek - Fotolia.com',
  copyrightText37: '© foxyburrow - Fotolia.com',
  copyrightText38: '© goodluz - Fotolia.com',
  copyrightText39: '© guteksk7 - Fotolia.com',
  copyrightText40: '© Halfpoint - Fotolia.com',
  copyrightText41: '© hati - Fotolia.com',
  copyrightText42: '© highwaystarz - Fotolia.com',
  copyrightText43: '© in4mal - Fotolia.com',
  copyrightText44: '© industrieblick - Fotolia.com',
  copyrightText45: '© interiorphoto - Fotolia.com',
  copyrightText46: '© Iriana Shiyan - Fotolia.com',
  copyrightText47: '© ivallis111 - Fotolia.com',
  copyrightText48: '© JackF - Fotolia.com',
  copyrightText49: '© jackfrog - Fotolia.com',
  copyrightText50: '© Jeanette Dietl - Fotolia.com',
  copyrightText51: '© jozsitoeroe - Fotolia.com',
  copyrightText52: '© JSB31 - Fotolia.com',
  copyrightText53: '© Julia Vadi - Fotolia.com',
  copyrightText54: '© Kadmy - Fotolia.com',
  copyrightText55: '© kange one - Fotolia.com',
  copyrightText56: '© Karin & Uwe Annas - Fotolia.com',
  copyrightText57: '© kasto - Fotolia.com',
  copyrightText58: '© KB3 - Fotolia.com',
  copyrightText59: '© KikoStock - Fotolia.com',
  copyrightText60: '© Konstantin Yuganov - Fotolia.com',
  copyrightText61: '© kontur-vid - Fotolia.com',
  copyrightText62: '© Kurhan - Fotolia.com',
  copyrightText63: '© Kzenon - Fotolia.com',
  copyrightText64: '© maho - Fotolia.com',
  copyrightText65: '© marcus_hofmann - Fotolia.com',
  copyrightText66: '© Michael Fleischmann - Fotolia.com',
  copyrightText67: '© Mihalis A. - Fotolia.com',
  copyrightText68: '© Monkey Business - Fotolia.com',
  copyrightText69: '© mystock2 - Fotolia.com',
  copyrightText70: '© Oleksandr Moroz - Fotolia.com',
  copyrightText71: '© panuwatsexy - Fotolia.com',
  copyrightText72: '© pattilabelle - Fotolia.com',
  copyrightText73: '© photo 5000 - Fotolia.com',
  copyrightText74: '© Photographee.eu - Fotolia.com',
  copyrightText75: '© photowahn - Fotolia.com',
  copyrightText76: '© Picture-Factory - Fotolia.com',
  copyrightText77: '© piotr_roae - Fotolia.com',
  copyrightText78: '© pixelkorn - Fotolia.com',
  copyrightText79: '© Pixelot - Fotolia.com',
  copyrightText80: '© pressmaster - Fotolia.com',
  copyrightText81: '© psdesign1 - Fotolia.com',
  copyrightText82: '© ras-slava - Fotolia.com',
  copyrightText83: '© Rawpixel.com - Fotolia.com',
  copyrightText84: '© rendermax - Fotolia.com',
  copyrightText85: '© Robert Kneschke - Fotolia.com',
  copyrightText86: '© Roland Spiegler - Fotolia.com',
  copyrightText87: '© Sashkin - Fotolia.com',
  copyrightText88: '© schulzfoto - Fotolia.com',
  copyrightText89: '© schwabenblitz - Fotolia.com',
  copyrightText90: '© sculpies - Fotolia.com',
  copyrightText91: '© Sergey Nivens - Fotolia.com',
  copyrightText92: '© slavun - Fotolia.com',
  copyrightText93: '© stockphoto mania - Fotolia.com',
  copyrightText94: '© stokkete - Fotolia.com',
  copyrightText95: '© Thomas Aumann - Fotolia.com',
  copyrightText96: '© Tiberius Gracchus - Fotolia.com',
  copyrightText97: '© tiero - Fotolia.com',
  copyrightText98: '© tina7si - Fotolia.com',
  copyrightText99: '© Tobias Arhelger - Fotolia.com',
  copyrightText100: '© Tomasz Zajda - Fotolia.com',
  copyrightText101: '© Tyler Olson - Fotolia.com',
  copyrightText102: '© vege - Fotolia.com',
  copyrightText103: '© vipman4 - Fotolia.com',
  copyrightText104: '© visivasnc - Fotolia.com',
  copyrightText105: '© WavebreakMediaMicro - Fotolia.com',
  copyrightText106: '© Wilm Ihlenfeld - Fotolia.com',
  copyrightText107: '© WoGi - Fotolia.com',
  copyrightText108: '© XtravaganT - Fotolia.com',
  copyrightText109: '© yurmary - Fotolia.com',
  copyrightText110: '© yuryrumovsky - Fotolia.com',
  copyrightText111: '© Виталий Сова - Fotolia.com',
  source: 'Quelle: ',
  sourceLink: 'SwissAnwalt',
}
